import { render, staticRenderFns } from "./MydtmPreferences.vue?vue&type=template&id=b7a4f356&"
import script from "./MydtmPreferences.vue?vue&type=script&lang=js&"
export * from "./MydtmPreferences.vue?vue&type=script&lang=js&"
import style0 from "./MydtmPreferences.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports